import { render, staticRenderFns } from "./AnAgentDetails.vue?vue&type=template&id=1bc679fc&scoped=true&"
import script from "./AnAgentDetails.vue?vue&type=script&lang=js&"
export * from "./AnAgentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnAgentDetails.vue?vue&type=style&index=0&id=1bc679fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc679fc",
  null
  
)

export default component.exports